import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../services/api";
import "./SearchPage.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faFutbol, faUsers, faSpinner, faEye } from "@fortawesome/free-solid-svg-icons";

function SearchPage() {
  const [searchTerm, setSearchTerm] = useState("");
  const [results, setResults] = useState({ teams: [], matches: [] });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (searchTerm.trim().length < 2) {
      setResults({ teams: [], matches: [] });
      return;
    }
    const delayDebounceFn = setTimeout(() => {
      handleSearch();
    }, 500);

    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);

  const handleSearch = async () => {
    setLoading(true);
    try {
      const response = await API.get(`/public/search?q=${searchTerm}`);
      setResults(response.data);
    } catch (error) {
      console.error("Erreur lors de la recherche front", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="search-page-container">
      <div className="search-header">
        <h1>Recherche Globale</h1>
        <div className="search-input-wrapper">
          <FontAwesomeIcon icon={faSearch} className="search-icon-inside" />
          <input
            type="text"
            placeholder="Rechercher un match, une équipe (ex: Real Madrid, Liga...)"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            autoFocus
          />
          {loading && <FontAwesomeIcon icon={faSpinner} spin className="loading-spinner" />}
        </div>
      </div>

      <div className="search-results-section">
        {/* SECTION ÉQUIPES */}
        {results.teams.length > 0 && (
          <div className="result-category">
            <h3><FontAwesomeIcon icon={faUsers} /> Équipes ({results.teams.length})</h3>
            <div className="teams-grid">
              {results.teams.map((team) => (
                <div key={team._id} className="team-search-card" onClick={() => setSearchTerm(team.name)}>
                  <img src={team.logo || "/default-team.png"} alt={team.name} />
                  <span>{team.name}</span>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* SECTION MATCHS */}
        {results.matches.length > 0 && (
          <div className="result-category">
            <h3><FontAwesomeIcon icon={faFutbol} /> Matchs ({results.matches.length})</h3>
            <div className="matches-list">
              {results.matches.map((match) => (
                <div 
                  key={match._id} 
                  className="match-search-card"
                  onClick={() => navigate(`/match/${match._id}`)} // Redirection vers le détail
                  style={{ cursor: "pointer" }}
                >
                  <div className="match-info">
                    <span className="league-badge">{match.country} - {match.league}</span>
                    <span className="match-date">{new Date(match.matchDate).toLocaleDateString()}</span>
                  </div>
                  <div className="match-teams-score">
                    <span className="team-name">{match.homeTeam}</span>
                    <span className="score-display">
                      {match.liveStatus !== "NS" 
                        ? `${match.goalsHome ?? 0} : ${match.goalsAway ?? 0}` 
                        : "vs"
                      }
                    </span>
                    <span className="team-name">{match.awayTeam}</span>
                  </div>
                  <div className="view-details-hint">
                    <FontAwesomeIcon icon={faEye} /> Voir détails
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* AUCUN RÉSULTAT */}
        {searchTerm.trim().length >= 2 && !loading && results.teams.length === 0 && results.matches.length === 0 && (
          <p className="no-results-msg">Aucun résultat trouvé pour "{searchTerm}"</p>
        )}
      </div>
    </div>
  );
}

export default SearchPage;